/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Backpac API
 * The Backpac API description
 * OpenAPI spec version: 1.0
 */

export type SettlementHistoryItemStatus = typeof SettlementHistoryItemStatus[keyof typeof SettlementHistoryItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettlementHistoryItemStatus = {
  AVAILABLE: 'AVAILABLE',
  IN_PROGRESS: 'IN_PROGRESS',
  PAID: 'PAID',
} as const;
